// 🔧 entries.js
// ✅ Purpose: Car Show entry template data for the LGV Seed Engine
// ✅ Features:
// - Stores realistic vehicle entry source data
// - Keeps industry content separate from generator logic
// - Supports future expansion to 50–75 car show entries
// - Future-ready for AI-generated or customer-specific seed data
// - Fully block-commented for clarity and future devs

export const CAR_SHOW_ENTRIES = [
  {
    year: "1967",
    make: "Chevrolet",
    model: "Camaro SS",
    color: "Bolero Red",
    description:
      "A frame-off restoration featuring a 396 big block, Rally wheels, restored interior, and period-correct details throughout.",
  },
  {
    year: "1969",
    make: "Ford",
    model: "Mustang Mach 1",
    color: "Acapulco Blue",
    description:
      "A beautifully preserved Mach 1 with shaker hood, upgraded suspension, and a highly detailed engine bay.",
  },
  {
    year: "1957",
    make: "Chevrolet",
    model: "Bel Air",
    color: "Matador Red",
    description:
      "A chrome-rich classic with two-tone paint, polished trim, whitewall tires, and a show-quality cabin.",
  },
  {
    year: "1970",
    make: "Dodge",
    model: "Challenger R/T",
    color: "Plum Crazy Purple",
    description:
      "A bold Mopar muscle build with a rumbling V8, period striping, and an aggressive stance.",
  },
  {
    year: "1964",
    make: "Pontiac",
    model: "GTO",
    color: "Nocturne Blue",
    description:
      "A clean early GTO representing the birth of the muscle car era with tasteful restoration work.",
  },
  {
    year: "1972",
    make: "Chevrolet",
    model: "C10",
    color: "Olive Green",
    description:
      "A lowered classic pickup with custom wheels, wood bed floor, and a clean cruiser-style finish.",
  },
  {
    year: "1993",
    make: "Toyota",
    model: "Supra Turbo",
    color: "Alpine Silver",
    description:
      "A sought-after import icon with tasteful performance upgrades, clean bodywork, and modernized details.",
  },
  {
    year: "2002",
    make: "Nissan",
    model: "Skyline GT-R",
    color: "Bayside Blue",
    description:
      "A legendary all-wheel-drive performance car with careful modifications and a show-ready presentation.",
  },
  {
    year: "1932",
    make: "Ford",
    model: "Roadster",
    color: "Gloss Black",
    description:
      "A traditional hot rod with exposed details, classic wheels, and timeless roadster proportions.",
  },
  {
    year: "2024",
    make: "Chevrolet",
    model: "Corvette Z06",
    color: "Rapid Blue",
    description:
      "A modern performance showcase with track-focused engineering, dramatic styling, and a high-revving V8.",
  },
  {
    year: "1965",
    make: "Ford",
    model: "Shelby GT350",
    color: "Wimbledon White",
    description:
      "A beautifully restored GT350 featuring period-correct styling and a high-revving small block.",
  },
  {
    year: "1963",
    make: "Chevrolet",
    model: "Corvette Split Window",
    color: "Riverside Red",
    description:
      "An iconic split-window coupe restored to concours quality with exceptional attention to detail.",
  },
  {
    year: "1955",
    make: "Chevrolet",
    model: "210",
    color: "Turquoise and White",
    description:
      "Classic Tri-Five styling with tasteful upgrades and a beautifully finished interior.",
  },
  {
    year: "1971",
    make: "Plymouth",
    model: "Cuda",
    color: "Vitamin C Orange",
    description:
      "A striking Mopar muscle car with factory styling and meticulous restoration work.",
  },
  {
    year: "1940",
    make: "Ford",
    model: "Deluxe Coupe",
    color: "Burgundy",
    description:
      "A timeless pre-war coupe blending traditional craftsmanship with tasteful modernization.",
  },
  {
    year: "1987",
    make: "Buick",
    model: "Grand National",
    color: "Black",
    description:
      "Turbocharged legend featuring immaculate paint, factory appearance, and outstanding originality.",
  },
  {
    year: "1998",
    make: "Subaru",
    model: "Impreza 2.5RS",
    color: "Sonic Blue",
    description:
      "A clean survivor representing the beginning of Subaru performance heritage.",
  },
  {
    year: "1966",
    make: "Pontiac",
    model: "Tempest",
    color: "Silver Mist",
    description:
      "A beautifully preserved Pontiac showcasing elegant styling and careful restoration.",
  },
  {
    year: "1950",
    make: "Mercury",
    model: "Eight",
    color: "Deep Maroon",
    description:
      "Traditional lead-sled styling with outstanding bodywork and chrome detailing.",
  },
  {
    year: "2023",
    make: "Ford",
    model: "Mustang Dark Horse",
    color: "Blue Ember",
    description:
      "A modern high-performance Mustang representing today's next generation of muscle cars.",
  },
];